import { abUseExperimentsSelector, isAbUseExperimentsActive } from 'shared/selectors';

import type { IState } from 'shared/store';

import { regionIdSelector } from '../offerData/geo/regionIdSelector';

export const PAID_REPORT_EXPERIMENT = 'sel_realty_report_card';

export const selectPaidReportExperiment = (state: IState, notTargetRegions: number[]): boolean => {
  const experiments = abUseExperimentsSelector(state);
  const regionId = regionIdSelector(state);

  const isPaidReportTargetRegion = regionId ? !notTargetRegions.includes(regionId) : false;

  return isPaidReportTargetRegion && isAbUseExperimentsActive(experiments, PAID_REPORT_EXPERIMENT, 'B');
};
